import React, { Component } from "react";

import { connect } from "react-redux";

import ChatList from "../../Container/ChatList/ChatList";
import Message from "../../Container/Message/Message";

import addUserData from "../../redux/actionCreators/addUserData";
import "./chatPage.css";
import { getSubscription } from "../../assets/Js/localStorage";

import projectSettings from "../../assets/Js/projectSettings";
import { callAPI } from "../../assets/Js/backendCommunication";
import { getPlainToken } from "../../assets/Js/tokenHandler";
import { immediateToast } from "izitoast-react";

const mapStateToProps = (state) => {
  return {
    selectedGym: state.selectedGym,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addUserInfo: (data) => dispatch(addUserData(data)),
  };
};

const initialState = {
  recieverId: "",
  groupId: "",
  UserName: "",
  image: null,
  isGroup: null,
  groupType: null,
  UsersFirstMessage: 0,
  RemoveUserWithThisId: null,
  resetMessageScreen: 0,
  allAthletesData: [],
  getNewChatList: 0,
  idOfUserFromUserList: "",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class ChatPage extends Component {
    constructor(props) {
      super(props);
      this.state = initialState;
    }

    componentDidMount() {
      this.getAllAthletesData();
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.selectedGym !== this.props.selectedGym) {
        this.getAllAthletesData();
      }
    }

    componentWillUnmount() {
      this.unreadMessages();
    }

    getAllAthletesData = async () => {
      let _gymId = this.props?.selectedGym?.Id;

      if (_gymId) {
        let url = `${projectSettings.baseUrl}/chats/getathletes`;
        let header = true;
        let type = "GET";
        let token = getPlainToken();
        let data = null;
        let response = "";
        if (response === "") {
          this.setState({ isLoading: true });
        }
        response = await callAPI(url, header, type, data, token);
        if (response) {
          this.setState({ isLoading: false });
          if (response.data.StatusCode === 200) {
            this.setState({
              allAthletesData: response.data.Result,
            });
          } else {
            if (data?.Errors?.length) {
              immediateToast("warning", { message: data.Errors[0] });
            }
          }
        }
      }
    };

    changeMessageList = async ({
      userId,
      groupId,
      UserName,
      image,
      isGroup,
      groupType,
    }) => {
      if (this.state.groupId) {
        await this.unreadMessages();
      }

      await this.setState({
        recieverId: userId,
        groupId: groupId,
        UserName: UserName,
        image: image,
        isGroup: isGroup,
        groupType: groupType,
      });
    };

    unreadMessages = async () => {
      let url = `${projectSettings.baseUrl}/chats/ReadMessages/${this.state.groupId}`;
      let header = true;
      let type = "POST";
      let data = null;
      let token = getPlainToken();

      await callAPI(url, header, type, JSON.stringify(data), token);
    };

    setUsersFirstMessage = async (newMessage) => {
      await this.setState((prevState) => {
        return {
          UsersFirstMessage: {
            firstMessageCount: ++prevState.UsersFirstMessage,
            firstMessage: newMessage.Message,
          },
        };
      });
    };

    setRemoveUserWithThisId = (id) => {
      this.setState({
        RemoveUserWithThisId: id,
      });
    };

    getNewChats = () => {
      this.setState({
        getNewChatList: ++this.state.getNewChatList,
      });
    };

    setGroupId = (groupId) => {
      this.setState({
        idOfUserFromUserList: groupId,
      });
    };

    resetMessageScreen = () => {
      this.changeMessageList({});
    };

    render() {
      return (
        <>
          <div
            className={`frame ${
              getSubscription() === "true" ? "frameHeight" : "frameHeight1"
            }`}
          >
            <ChatList
              backPress={() => {
                this.props.backPress();
              }}
              idOfUserFromUserList={this.state.idOfUserFromUserList}
              changeMessageList={this.changeMessageList}
              firstMessageInfo={this.state.UsersFirstMessage}
              removeUserWithThisId={this.state.RemoveUserWithThisId}
              allAthletesData={this.state.allAthletesData}
              getNewChatList={this.state.getNewChatList}
              getNewChats={this.getNewChats}
            />
            <Message
              isGroup={this.state.isGroup}
              receiverImage={this.state.image}
              recieverId={this.state.recieverId}
              groupId={this.state.groupId}
              UserName={this.state.UserName}
              groupType={this.state.groupType}
              allAthletesData={this.state.allAthletesData}
              setUsersFirstMessage={this.setUsersFirstMessage}
              setRemoveUserWithThisId={this.setRemoveUserWithThisId}
              resetMessageScreen={this.resetMessageScreen}
              changeMessageList={this.changeMessageList}
              getNewChats={this.getNewChats}
              setGroupId={this.setGroupId}
            />
          </div>
        </>
      );
    }
  }
);
